import React, { useState, useEffect } from 'react';
import { NoBuilding } from '../../common';

import './ElectricityTable.css';
import '../../styles/billingPageStyles.css'

const convertString2Int = (string) => {
    return parseInt(String(string).replace(/,/g, ''), 10) || 0
};

const convertInt2String = (num) => {
    return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
};

const ElectricityTable = ({ hasBuilding, roomInfo, setRoomInfo }) => {
    const [displayValues, setDisplayValues] = useState({});
    
    useEffect(() => {
        const initialDisplayValues = roomInfo.reduce((acc, room) => {
            acc[room.roomId] = {
                roomElecChangePrice: convertInt2String(room.roomElecChangePrice),
                memoElec: room.memoElec || ""
            }
            return acc;
        }, {});
        setDisplayValues(initialDisplayValues);
    }, [roomInfo]);

    const handleChange = (id, className, e) => {
        const inputValue = e.target.value;
        if (/^-?\d*$/.test(inputValue)) { // 맨 앞에는 -를 허용하고 그 뒤로는 숫자만 허용
            setDisplayValues(prevValues => ({
                ...prevValues,
                [id]: {
                    ...prevValues[id],
                    [className]: inputValue
                }
            }))
        }
    };

    const handleTextChange = (id, className, e) => {
        const inputValue = e.target.value;
        setDisplayValues(prevValues => ({
            ...prevValues,
            [id]: {
                ...prevValues[id],
                [className]: inputValue
            }
        }))
    };

    const handleBlur = (id, className, e) => {
        const inputValue = convertString2Int(e.target.value);
        setRoomInfo(id, className, inputValue);

        setDisplayValues(prevValues => ({
            ...prevValues,
            [id]: {
                ...prevValues[id],
                [className]: convertInt2String(inputValue)
            }
        }));
    };

    const handleTextBlur = (id, className, e) => {
        const inputValue = e.target.value;
        setRoomInfo(id, className, inputValue);

        setDisplayValues(prevValues => ({
            ...prevValues,
            [id]: {
                ...prevValues[id],
                [className]: inputValue
            }
        }));
    };

    const handleFocus = (id, className, e) => {
        const inputValue = convertString2Int(e.target.value)
        setDisplayValues(prevValues => ({
            ...prevValues,
            [id]: {
                ...prevValues[id],
                [className]: inputValue === 0 ? '' : inputValue
            }
        }));
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.target.blur(); // 엔터 키를 누르면 포커스를 잃도록 처리
        }
    };

    return (
        <table className="table">
            <thead>
                <tr>
                    <th className='whiteTable elecTableColumn1 tableHead'>호실명</th>
                    <th className='whiteTable elecTableColumn2 tableHead'>임차사명</th>
                    <th className='whiteTable elecTableColumn3 tableHead'>전용면적</th>
                    <th className='whiteTable elecTableColumn4 tableHead'>임대비율</th>
                    <th className='grayTable elecTableColumn5 tableHead'>전기요금</th>
                    <th className='grayTable elecTableColumn6 tableHead'>부가가치세</th>
                    <th className='grayTable elecTableColumn7 tableHead'>과세 합계</th>
                    <th className='orangeTable elecTableColumn8 tableHead'>전력기금</th>
                    <th className='orangeTable elecTableColumn9 tableHead'>TV수신료</th>
                    <th className='orangeTable elecTableColumn10 tableHead'>비과세 합계</th>
                    <th className='grayTable elecTableColumn11 tableHead'>총 합계</th>
                    <th className='redTable elecTableColumn12 tableHead'>금액 조정</th>
                    <th className='blueTable blueFont elecTableColumn13'>청구 금액
                        <br/>
                        <span className="tableAdditional">
                            (원단위 절삭)
                        </span>
                    </th>
                    <th className='grayTable elecTableColumn14 tableHead'>비고</th>
                </tr>
            </thead>
            <tbody>
                {hasBuilding === false ? (
                    <tr>
                        <td colSpan="14">
                            <NoBuilding />
                        </td>
                    </tr>
                ) : (
                    roomInfo.filter(room => room.roomStatus === "CONTRACT").length === 0 ? (
                        <tr>
                            <td colSpan="14">
                                <NoBuilding message="호실 상태가 입실인 호실을 추가해주세요!" />
                            </td>
                        </tr>
                    ) : (
                        roomInfo
                        .filter(room => room.roomStatus === "CONTRACT")
                        .concat(roomInfo.filter(room => room.roomStatus !== "CONTRACT"))
                        .map(room => {
                            return (
                                <tr key={room.roomId}>
                                    <td className='whiteTable elecTableColumn1 blueFont boldFont tableChild'>{room.roomName}</td>
                                    <td className={`whiteTable elecTableColumn2 tableChild ${room.roomStatus !== "CONTRACT" ? "noCustomerStyle customerStyle" : "customerStyle"}`}>{room.roomStatus === "CONTRACT" ? room.roomCustomerName : room.roomStatus === "EMPTY" ? "공실" : "공용"}</td>
                                    <td className='whiteTable elecTableColumn3 tableChild'>{convertInt2String(room.roomPrivateArea || 0)}m²</td>
                                    <td className='whiteTable elecTableColumn4 tableChild'>{(room.privateAreaRatio * 100).toFixed(1)}%</td>
                                    <td className='grayTable elecTableColumn5 tablePrice tableChild'>{convertInt2String(room.elecPrice)}원</td>
                                    <td className='grayTable elecTableColumn6 tablePrice tableChild'>{convertInt2String(room.elecVAT)}원</td>
                                    <td className='grayTable elecTableColumn7 tablePrice boldFont tableChild'>{convertInt2String(room.totalTaxPrice)}원</td>
                                    <td className='orangeTable elecTableColumn8 tablePrice tableChild'>{convertInt2String(room.elecFund)}원</td>
                                    <td className='orangeTable elecTableColumn9 tablePrice tableChild'>{convertInt2String(room.elecTV)}원</td>
                                    <td className='orangeTable elecTableColumn10 tablePrice boldFont tableChild'>{convertInt2String(room.totalTaxFreePrice)}원</td>
                                    <td className='grayTable elecTableColumn11 tablePrice boldFont tableChild'>{convertInt2String(room.totalTaxAndTaxFreePrice)}원</td>
                                    <td className='redTable elecTableColumn12'>
                                        <input
                                            className={`tableInputBoxInput ${room.roomStatus === "CONTRACT" ? 'contract-style' : 'non-contract-style'}`}
                                            type="text"
                                            value={displayValues[room.roomId]?.roomElecChangePrice || ''}
                                            placeholder='0'
                                            onChange={(e) => handleChange(room.roomId, 'roomElecChangePrice', e)}
                                            onBlur={(e) => handleBlur(room.roomId, 'roomElecChangePrice', e)}
                                            onFocus={(e) => handleFocus(room.roomId, 'roomElecChangePrice', e)}
                                            onKeyPress={handleKeyPress}
                                        />
                                    </td>
                                    <td className='blueTable blueFont elecTableColumn13 tablePrice boldFont tableChild'>{convertInt2String(room.totalPrice)}원</td>
                                    <td className='grayTable elecTableColumn14 tableHead'>
                                        <input
                                            className={"tableInputBoxMemo"}
                                            type="text"
                                            value={displayValues[room.roomId]?.memoElec || ''}
                                            placeholder="특이사항 메모"
                                            onChange={(e) => handleTextChange(room.roomId, 'memoElec', e)}
                                            onBlur={(e) => handleTextBlur(room.roomId, "memoElec", e)}
                                            onKeyPress={handleKeyPress}
                                        ></input>
                                    </td>
                                </tr>
                            );
                        })
                    )
                )}
            </tbody>
        </table>
    );
};

export default ElectricityTable;
